import React from "react";

interface Props {
  size?: number;
}

const HomeIcon = ({ size = 16 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 6.5V11H9V6.5" stroke="currentColor" />
      <path d="M11 6.28564L6 1.99993L1 6.28565" stroke="currentColor" />
    </svg>
  );
};

export default HomeIcon;
